<div class="page">
    <div class="page-padding">
        <div class="page-header-custom">
            <svg-icon src="assets/svg/child.svg"></svg-icon>
            <h1 class="page-title">{{'daycare.novacrianca'|translate}}</h1>
            <a class="btn btn-gray-fill" [routerLink]="['/daycare']">{{'voltar'|translate}}</a>
        </div>

        <div class="daycare-card">
            <div class="daycare-grid">
                <div class="input-material" *ngIf="showUnitySelector">
                    <select id="unity" [(ngModel)]="form.unityId" class="form-control">
                        <option [ngValue]="null" disabled>{{'daycare.selecioneunidade'|translate}}</option>
                        <option *ngFor="let u of unities" [ngValue]="u.id">{{u.name}}</option>
                    </select>
                    <label for="unity" class="mb-0 mr-3">{{'unidade'|translate}}</label>
                </div>
                <div class="input-material">
                    <input id="name" [(ngModel)]="form.name" class="form-control" type="text" required/>
                    <label for="name">{{'crianca'|translate}} *</label>
                </div>
                <div class="input-material">
                    <input id="year" [(ngModel)]="form.year" class="form-control" type="number"/>
                    <label for="year">{{'daycare.ano'|translate}}</label>
                </div>
                <div class="input-material">
                    <input id="re" [(ngModel)]="form.employeeRe" class="form-control" type="text" required/>
                    <label for="re">{{'re'|translate}} *</label>
                </div>
                <div class="input-material">
                    <input id="empName" [(ngModel)]="form.employeeName" class="form-control" type="text" required/>
                    <label for="empName">{{'colaborador'|translate}} *</label>
                </div>
                <div class="input-material">
                    <input id="empEmail" [(ngModel)]="form.employeeEmail" class="form-control" type="text"/>
                    <label for="empEmail">E-mail</label>
                </div>
            </div>
        </div>

        <!-- Guardiões (opcional) -->
        <div class="daycare-card mt-3">
            <div class="daycare-card-head">
                <h5 class="mb-0">{{'pessoasautorizadas'|translate}}</h5>
                <button type="button" class="btn btn-sm btn-secondary text-white" [disabled]="loading" (click)="addGuardianRow()">
                    <svg-icon class="mr-1" src="assets/svg/plus-circle.svg"></svg-icon>{{'daycare.adicionarguardiao'|translate}}
                </button>
            </div>

            <p *ngIf="!guardians.length" class="text-muted"><small>{{'daycare.guardiaoopcional'|translate}}</small></p>

            <div class="daycare-guardian-row" *ngFor="let g of guardians; let i = index">
                <div class="input-material">
                    <select [(ngModel)]="g.kind" class="form-control">
                        <option value="authorized">{{'daycare.autorizado'|translate}}</option>
                        <option value="parent">{{'paimae'|translate}}</option>
                    </select>
                    <label class="mb-0 mr-3">{{'daycare.tipo'|translate}}</label>
                </div>
                <div class="input-material">
                    <input [(ngModel)]="g.name" class="form-control" type="text" placeholder="{{'daycare.nome'|translate}}"/>
                    <label>{{'daycare.nome'|translate}}</label>
                </div>
                <div class="input-material">
                    <input [(ngModel)]="g.documentRaw" class="form-control" type="text"/>
                    <label>{{'daycare.documento'|translate}}</label>
                </div>
                <svg-icon (click)="removeGuardianRow(i)" src="assets/svg/close-red.svg" class="daycare-remove-row"></svg-icon>
            </div>
        </div>

        <div class="text-right mt-3">
            <button type="button" class="btn btn-primary btn-lg text-white" [disabled]="loading" (click)="save()">
                {{'salvar'|translate}}
            </button>
        </div>
    </div>
</div>
